import React, { useState, useRef, useEffect } from 'react'
import Share from './share'
import { IContainerprops } from './shareinterface';
import alertservice from '../../../../services/alertservice';
import { useSelector } from 'react-redux';
import { selectors as headerSelector } from "../../../../state/features/header";
import isEqual from 'lodash/isEqual';
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../../const/resource";
import { selectors as globalDataSelector } from "../../../../state/features/common/globaldata";
import DistributorService from "../../../../services/distributorservice";
import helperfunctions from '../../../../utils/helperfunctions';

function ShareContainer(props: IContainerprops) {
    const { t } = useTranslation();
    const [tags, setTags] = useState<any>([]);
    const [suggestions, setSuggestions] = useState<any>({ loading: false, data: [] });
    const stateSearchTextRef = useRef();
    const [distributorId, setDistributorId] = useState<any>([]);
    const { headercurrentuser }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state),
        })
    );

    useEffect(() => {
        getDistributorData();
    }, [])

    const getDistributorData = () => {
        DistributorService.getDistributors(userId)
            .then(async (response: any) => {
                const data: any = await response;
                const distributor = data?.find((s: any) => s.id == globalData.DistributorCode)
                setDistributorId(distributor?.dbId);
            }).catch((e: any) => { });
    };

    const { globalData }: any = useSelector((state) => ({
        globalData: globalDataSelector.globaldata(state),
    }));

    const userId = headercurrentuser != null ? headercurrentuser?.azureADId : "";

    const handleAddTag = (tag: any) => {
        if (tag?.id != "") {
            setTags([...tags, tag]);
            setSuggestions({ loading: false, data: [] });
        }
    };

    const handleDeleteTag = (index: any) => {
        const newTags = tags.filter((_: any, i: any) => i !== index);
        setTags(newTags);
        setSuggestions({ loading: false, data: [] });
        handleAlertClose();
    };

    const onEmailInputChange = (value: any) => {
    return value;
    };

    const getEmail = (emailText: any) => {
        return emailText.slice(
            emailText.lastIndexOf("(") + 1,
            emailText.lastIndexOf(")"),
        );
    }

    const processEmailSuggestionForShare = (dataResult: any) => {
        let result = dataResult.map((item: any) => {
            return {
                id: getEmail(item.email),
                text: item.email
            };
        });

        if (result?.length > 0) {
            result.push({ id: "", text: t(RESOURCE.MyK_Label_SC_NoteInformation) })
        }

        return result;
    }

    const getEmailSuggestions = async (item: any) => {
        if (item) {
            try {
                let model = {
                    "userAadId": userId,
                    "filterText": item,
                    "customerIds": globalData.CustomerId,
                    "distributorIds": distributorId??globalData.DistributorCode,
                    "locationIds": globalData.LocationId,
                    "isQuoteRequest": true
                }
                setSuggestions({ loading: true, data: [] });
                const response: any = await alertservice.getEmailIdSuggetion(model, item ?? '');
                let dataProcessed = [];
                const areEqual = isEqual(response?.searchText, item);
                if (areEqual) {
                    dataProcessed = processEmailSuggestionForShare(response?.results);
                    setSuggestions({ loading: false, data: dataProcessed });
                }
            } catch (error) {
                setSuggestions({ loading: false, data: [] });
                props.setErrorShareMsg(t(RESOURCE.MyK_Email_Suggestions_Error_Msg));
            }
        }
    };

    const onEmailText = (item: any) => {
        handleAlertClose();
        setSuggestions((prevState: any) => ({
            ...prevState,
            data: []
        }));
        stateSearchTextRef.current = item;
        if (item?.length >= 2) {
            getEmailSuggestions(item);
        }
    };

    const handleInputBlur = (value:any = '') => {
        let suggestionsData = suggestions?.data?.length ? suggestions?.data : [];
        const isValueMatched = suggestionsData.some((item: any) => {
            if(item.id === value){
            setTags([...tags, item]);
            return true;
            }
        });
        if (!isValueMatched && helperfunctions.validEmailCheck(value.trim())) {
            setTags([...tags, {id: value, text: value}]);
        }
        setSuggestions({ loading: false, data: [] });
    }

    const onClickSend = () => {
        if (tags?.length) {
            props?.shareQuoteService(tags);
        } else {
            props.setErrorShareMsg(t(RESOURCE.MyK_Label_SC_UserEmail_Required));
            props.setShowShareAlert(true);
        }
    };

    const handleAlertClose = () => {
        props.setErrorShareMsg("");
        props.setShowShareAlert(false);
    };

    return (
        <Share
            openSharePopup={props?.openSharePopup}
            selectedItem={props?.selectedItem}
            shareQuoteService={props?.shareQuoteService}
            handleAlertClose={handleAlertClose}
            tags={tags}
            suggestions={suggestions}
            onEmailText={onEmailText}
            onEmailInputChange={onEmailInputChange}
            handleAddTag={handleAddTag}
            handleDeleteTag={handleDeleteTag}
            onClickSend={onClickSend}
            showShareAlert={props.showShareAlert}
            setShowShareAlert={props.setShowShareAlert}
            errorShareMsg={props.errorShareMsg}
            setErrorShareMsg={props.setErrorShareMsg}
            handleInputBlur={handleInputBlur}
        />
    )
}

export default ShareContainer